import React from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import styled from 'styled-components';

const Shots = React.createClass({
  render () {
    if(!this.props.shots) {
      return (
        <div className="work">
          <h3>Loading...</h3>
        </div>
      );
    }

    // var shotData = this.props.shots.map(function(shot) {
    //   return (
    //     <WorkItem
    //       image={ shot.images.normal }
    //       title={ shot.title }
    //       description={ shot.description }
    //       likes={ shot.likes_count }
    //       layout={ layout }
    //       key={ shot.id }
    //     />
    //   );
    // });

    return (
      <ShotsContainer>
        {this.props.shots.map((shot) =>
          <Shot>
            <a href={shot.html_url}>
              <img src={shot.images.normal} title={shot.title} />
            </a>
          </Shot>
        )}
      </ShotsContainer>
    )
  }
});

const ShotsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding-top: 10px;
  padding-bottom: 40px;
  margin: 0 -80px;
`;

const Shot = styled.div`
  width: 260px;
  margin-bottom: 20px;
  box-shadow: 0 5px 20px 0 rgba(48,42,51,0.03);

  img {
    max-width: 100%;
    border-radius: 4px;
    display: block;
  }
`;

module.exports = Shots;



// WEBPACK FOOTER //
// ./components/shots.js